import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from './translate.service';

@Pipe({
  name: 'translate',
  pure: false,
  standalone: false
})
export class TranslatePipe implements PipeTransform {


  constructor(private _translate: TranslateService) { }

  transform(value: string, args?: string | string[]): any {
    if (!value) { return; }

    return this._translate.instant(value, args);
  }

}
